import React from 'react';
import ClientResultCard from './ClientResultCard';

const SearchResultsGrid = ({ 
  clients, 
  searchQuery, 
  onAddMinutes, 
  onSubtractMinutes,
  isLoading 
}) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="flex justify-between items-start mb-4">
              <div className="flex-1">
                <div className="h-5 bg-muted rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-muted rounded w-1/2"></div>
              </div>
              <div className="text-right">
                <div className="h-8 bg-muted rounded w-12 mb-1"></div>
                <div className="h-3 bg-muted rounded w-16"></div>
              </div>
            </div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-2 h-2 bg-muted rounded-full"></div>
              <div className="h-3 bg-muted rounded w-20"></div>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-muted rounded-full"></div>
              <div className="h-3 bg-muted rounded w-24"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {clients.map((client) => (
          <ClientResultCard
            key={client.id}
            client={client}
            searchQuery={searchQuery}
            onAddMinutes={onAddMinutes}
            onSubtractMinutes={onSubtractMinutes}
          />
        ))}
      </div>
    </div>
  );
};

export default SearchResultsGrid;